module.exports = __webpack_public_path__ + "media/images/samples/home/ig2@2x-8870278f5dc6e09644eda6c14702e357.png";